export default {"src":"/_next/static/media/popeyes-not-found.aee07e2c.svg","height":320,"width":320,"blurWidth":0,"blurHeight":0};